<template>
  <div class="-slider-box -saturation-slider">
    <span>Saturation</span>
    <div
      class="-slider"
      ref="slider"
      @mousedown="
        mouseDown($event);
        clickOnSlider($event);
      "
      :style="[backgroundReflection]"
    >
      <div
        class="-handle"
        ref="handle"
        :style="{
          left: sliderPosition - 2 + '%',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import sliderMixin from '../mixins/slider.vue';

export default {
  mixins: [sliderMixin],

  props: {
    hsl: {
      type: Object,
      required: true,
    },

    standalone: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    backgroundReflection() {
      const iterations = 6;
      let result = '-webkit-linear-gradient(left, ';
      const s = this.standalone;

      for (let i = 0; i < iterations; i++) {
        result += `hsla(${this.hsl.h},${i * 20}%,${
          s ? 50 : this.hsl.l * 100
        }%,1)`;
        result += i + 1 === iterations ? '' : ',';
      }

      return {
        // apparently, chrome is converting any format (hsla, hex and etc)
        // to rgb/a, if it is defined by js in style
        // example: https://jsfiddle.net/Herteby/2y9b5qLx/2/
        background: result + ')',
      };
    },

    sliderPosition() {
      return _.constrain(0, app.sfp(this.hsl.s * 100, 1e2), 100);
    },
  },

  methods: {
    getSliderNewPosition(e) {
      const slider = this.$refs.slider;
      const sliderRect = slider.getBoundingClientRect();
      const difference = e.clientX - sliderRect.left;
      const divider = sliderRect.width / difference;
      return _.constrain(0, app.sfp(100 / divider / 100, 1e2), 1);
    },

    clickOnSlider(e) {
      const handle = this.$refs.handle;
      const isClickedHandle = handle.contains(e.target);

      // clicked on slider, and not on handle
      if (!isClickedHandle) {
        this.setNewHsl(e);
      }
    },

    setNewHsl(e) {
      const newPosition = this.getSliderNewPosition(e);
      this.$emit('update-hsl', { s: newPosition });
    },

    onMouseMove(e) {
      this.setNewHsl(e);
    },
  },
};
</script>
